import React, { useState } from 'react';
import StaggeredMenu from './StaggeredMenu';
import assetUrl from '../../utils/assetUrl';

const Navigation = ({ onNewsletterClick, isRetro = false }) => {
  const [open, setOpen] = useState(false);
  const menuItems = [
    { label: 'Home', ariaLabel: 'Go to home page', link: '#/' },
    { label: 'Eve', ariaLabel: 'Learn about Eve', link: '#/eve' },
    { label: 'Team', ariaLabel: 'Meet our team', link: '#/team' }
  ];

  const socialItems = [
    { label: 'YouTube', link: 'https://www.youtube.com/@AlurenDynamics' },
    { label: 'Instagram', link: 'https://www.instagram.com/alurendynamics/' },
    { label: 'X (Twitter)', link: 'https://x.com/AlurenDynamics' },
    { label: 'Facebook', link: 'https://www.facebook.com/profile.php?id=61586061127086' },
    { label: 'Email', link: 'mailto:contact@alurendynamics.com' }
  ];

  const handleItemClick = () => false;

  const logoUrl = isRetro ? assetUrl('ALUREN WHT-pixelated.png') : assetUrl('logo.png');

  if (isRetro) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          padding: '0.75rem 1rem',
          background: 'transparent',
          borderBottom: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '1rem'
        }}
      >
        <img
          src={logoUrl}
          alt="Aluren Dynamics"
          style={{ height: 32, imageRendering: 'pixelated' }}
        />
        <div style={{ position: 'relative' }}>
          <button
            type="button"
            className="retro-nav-trigger"
            onClick={() => setOpen((prev) => !prev)}
            aria-haspopup="menu"
            aria-expanded={open}
          >
            MENU
          </button>
          {open && (
            <div className="retro-nav-menu" role="menu">
              {menuItems.map((item) => (
                <button
                  key={item.label}
                  type="button"
                  className="retro-nav-item"
                  role="menuitem"
                  onClick={(e) => {
                    setOpen(false);
                    if (handleItemClick(item, e)) return;
                    window.location.href = item.link;
                  }}
                >
                  {item.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <StaggeredMenu
      position="right"
      items={menuItems}
      socialItems={socialItems}
      displaySocials={true}
      displayItemNumbering={true}
      menuButtonColor="#ffffff"
      openMenuButtonColor="#000000"
      changeMenuColorOnOpen={true}
      colors={['#B19EEF', '#5227FF']}
      logoUrl={logoUrl}
      accentColor="#5227FF"
      isFixed={true}
      onMenuOpen={() => console.log('Menu opened')}
      onMenuClose={() => console.log('Menu closed')}
      onItemClick={handleItemClick}
    />
  );
};

export default Navigation;